import { byUser } from 'src/feathers/hooks';

export default (app) => {
  const service = app.service('api/job-stats');
  service.name = 'jobStats';

  service.hooks({
    before: {
      all: [byUser],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
